import request from '@/utils/request'

/**
 * 查询入库单详情
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询入库单商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrderProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrderProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存入库单
 * @param {Object} data 保存数据
 * @returns {Promise} 返回Promise对象
 */
export function saveOrderIn(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/saveOrderIn',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新入库单
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export function updateInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/updateInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新入库单商品
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export function updateInoutOrderProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrderProduct/updateInoutOrderProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}